import React, { useState } from "react";
import { ChevronDown, ChevronRight, Zap } from "lucide-react";

import { Chip } from "@/shared/components/ui-kit";
import { ArgsTable } from "./ArgsTable";

import type { AppTriggerSpec } from "@/shared/types";

/* Read-only on purpose (00-PLAN Decisions): a subscription belongs to one
   agent, with its own config and its own prompt, so it is made in that agent's
   Configure panel. Here the catalog only says what the provider can announce. */
export function TriggerRow({ trigger }: { trigger: AppTriggerSpec }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-t hairline first:border-t-0">
      <button
        onClick={() => setOpen((v) => !v)}
        className="w-full press flex items-center gap-3 px-4 py-3 text-left hover:bg-[var(--accent-hover)]"
      >
        {open
          ? <ChevronDown className="w-3.5 h-3.5 text-[var(--text-tertiary)] shrink-0" strokeWidth={1.75} />
          : <ChevronRight className="w-3.5 h-3.5 text-[var(--text-tertiary)] shrink-0" strokeWidth={1.75} />}
        <Zap className="w-3.5 h-3.5 shrink-0 text-[var(--text-quaternary)]" strokeWidth={1.75} />
        <div className="min-w-0 flex-1">
          {/* The slug drops under the name when both do not fit, rather than truncating to a few letters */}
          <div className="flex flex-wrap items-baseline gap-x-2 min-w-0">
            <span className="min-w-0 break-words text-[14px] font-medium text-[var(--text-primary)] tracking-[-0.005em]">
              {trigger.name}
            </span>
            <code className="min-w-0 max-w-full text-[11px] text-[var(--text-quaternary)] truncate">{trigger.slug}</code>
          </div>
          <div className="text-[12.5px] text-[var(--text-secondary)] mt-[1px] truncate">{trigger.desc}</div>
        </div>
        <Chip>{trigger.type}</Chip>
      </button>
      {open && (
        <div className="fade-in">
          {trigger.instructions && (
            <p className="px-4 pt-1 text-[12.5px] leading-[1.55] text-[var(--text-secondary)] m-0">
              {trigger.instructions}
            </p>
          )}
          <ArgsTable args={trigger.config} label="Configuration" />
          <ArgsTable args={trigger.payload} label="Event payload" />
        </div>
      )}
    </div>
  );
}
